<template>
    <v-container grid-list-md class="fb-post-create-process">
        <v-layout row wrap>
            <v-flex md10>
                <v-form ref="form_fb_post_process">
                <v-layout align-center row class="pa-0">
                    <v-flex md4>
                        <label class="text-color-vip">Link hoặc ID profile cần cài VIP:</label>
                    </v-flex>
                    <v-flex md8>
                        <v-text-field
                                solo
                                v-model="linkOrId"
                                placeholder="Nhập link hoặc ID cần tăng"
                                required
                        ></v-text-field>
                    </v-flex>
                </v-layout>

                    <!--videoRef-->
                    <v-layout align-center row v-if="videoId">
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <a href="#videoRef">
                                    <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>

                <v-layout align-center row>
                      <v-flex md4>
                          <label class="text-color-vip">Số lượng TYM cần tăng mỗi video :</label>
                      </v-flex>
                      <v-flex md8>
                          <v-select
                              solo
                              :items="amountMaxList"
                              v-model="amountMax"
                          ></v-select>
                      </v-flex>
                </v-layout>

                <v-layout align-center row>
                  <v-flex md4>
                    <label class="text-color-vip">Số lượng VIEW cần tăng mỗi video :</label>
                  </v-flex>
                  <v-flex md8>
                    <v-select
                        solo
                        :items="amountViewList"
                        v-model="amountView"
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-layout align-center row>
                      <v-flex md4>
                          <label class="text-color-vip">Số ngày cần mua Vip:</label>
                      </v-flex>
                      <v-flex md8>
                          <v-select
                                  solo
                                  :items="noDays"
                                  v-model="day"
                          ></v-select>
                      </v-flex>
                </v-layout>
                <v-layout align-center row>
                  <v-flex md4>
                    <label class="text-color-vip">Số bài viết tối đa 1 ngày:</label>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                        solo
                        v-model="maxPost"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout align-center row class="pa-0">
                    <v-flex md12>
                        <v-card dark color="lime lighten-5" class="">
                            <v-card-text class="ml-5 black--text">
                                <p class="info-account">
                                    Tổng tiền của gói vip sẽ =
                                  <br>
                                  (Số lượng Like tối đa) x (Số ngày đăng ký VIP) x (Giá tiền order mỗi like) x (Số lượng video tối đa trong ngày)
                                  <br>
                                  + (Số lượng view tối đa) x (Số ngày đăng ký VIP) x (Giá tiền order mỗi view) x (Số lượng video tối đa trong ngày)
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>

                <br>
                <v-card dark color="lime lighten-5" class="mb-2">
                    <v-card-text class="black--text">
                        <p class="info-account">
                            - VIP Tiktok là gói Vip giá rẻ tự động tăng Like và View mỗi khi bạn đăng video mới
                        </p>
                        <p class="info-account">
                            - Người Like là tài khoản Tiktok Việt Nam.
                        </p>
                        <p class="info-account">
                            - Ví dụ: Bạn mua 7 ngày, mỗi bài 50 like thì tổng tiền bạn phải trả là {{totalCoin | currency_init}} coin. Hệ thống mỗi ngày sẽ tăng mỗi bài viết 50 like và tối đa tăng cho 5 bài viết.
                        </p>
                    </v-card-text>
                </v-card>

                <v-layout align-center row class="mt-2">
                    <v-flex md4>
                        <label class="text-color-vip">Ghi chú:</label>
                    </v-flex>
                    <v-flex md8>
                        <v-textarea
                                solo
                                v-model="notes"
                                placeholder="Nhập nội dung ghi chú về tiến trình của bạn"
                                height="70px"
                        ></v-textarea>
                    </v-flex>
                </v-layout>

                </v-form>

                <v-layout align-center row class="mt-2">
                    <v-flex md12>
                        <v-card :color="COLOR.VIP" height="120px">
                            <v-card-title>
                                <div class="div-total">
                                    <p>
                                        Tổng: <strong>{{totalCoin | currency_init}}</strong> Coin <br>
                                        Bạn sẽ mua vip <strong>{{amountMax}}</strong> trong <strong>{{ day }}</strong> ngày
                                    </p>
                                </div>

                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout align-center row class="mt-2">
                    <v-flex md12>
                        <v-btn width="100%" height="50px" :color="COLOR.MAIN_COLOR" class="white--text" @click="saveProcess">
                            Tạo tiến trình
                        </v-btn>
                    </v-flex>
                </v-layout>

                <!--video youtube-->
                <v-layout align-center row v-if="videoId" id="videoRef">
                    <v-flex md12>
                        <div class="col-sm-12 mb-n3">
                            <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                        </div>
                        <div class="col-sm-12 mb-n3">
                            <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                            </youtube>
                        </div>
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex md2 text_notes>
                <VipLikeTiktokAttention />
            </v-flex>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular
                    indeterminate
                    color="info"
            ></v-progress-circular>
        </v-overlay>
    </v-container>


</template>

<script>
    import VipLikeTiktokAttention from "~/components/vip-like-tiktok/VipLikeTiktokAttention";
    import { COLOR, SEEDING } from "~/config/constant";
    import Swal from 'sweetalert2';
    import {VIP_FACE_GET_SEEDING, TIKTOK_VIP_LIKE_SAVE_ORDER, VIP_FACE_CALCULATE} from "~/store/actions.type";
    import $ from 'jquery';

    export default {
        name: "FbPostCreateProcess",
        components: {
            VipLikeTiktokAttention
        },
        data() {
            return {
                overlay: false,
                // Color chinh
                 COLOR: COLOR,
                 SEEDING: SEEDING,

                //LINK
                linkOrId: "",

                // amount
                amountMin: 40,
                amountViewList: [],
                amountView: 0,
                amountMaxList: [],
                amountMax: 50,
                minMin: 40,
                maxPost: 5,

                // SO NGAY CAN MUA VIP
                day: 7,
                noDays: [7,30,60,90],

              // Gia tien
                price: 12,
                priceView : 15,
                priceUnit: '  coin/ 1 like',
                priceMin: 12,
                notePrice: "Giá thấp nhất: 12 coin",

                // Ghi chu
                notes: "",

                // Tong so coin
                totalCoin: 21000,

                // Rules

                videoId: '',
                videoStatus: true,
            }
        },

        created() {
            this.amountMinList = [40,50,100,150,200,300,400,500,600,700,800,900];
            this.amountMaxList = [50,100,150,200,300,400,500,600,700,800,900];
            this.amountViewList = [0,1000,1500,2000,2500,3000,3500,4000,4500,5000];

            for (let i = 1000; i <= 30000; i+=200) {
                this.amountMinList.push(i);
                this.amountMaxList.push(i);
            }

            for (let i = 5000; i <= 100000; i+=5000) {
                this.amountViewList.push(i);
            }

            this.customDataFromApi();
        },

        watch: {
          day() {
            this.calculate();
          },
          amountMax() {
             this.calculate();
          },
          price() {
              this.calculate();
          },
          maxPost() {
              this.calculate();
          },
          amountView() {
              this.calculate();
          }

        },
        computed: {

        },
        mounted() {
         if ($('.menu-fbvip-buff').parent().attr('aria-expanded') == "false") {
           $('.menu-fbvip-buff').click();
         }
        },
        methods: {
            async customDataFromApi() {
              let data  =  await this.$store.dispatch(VIP_FACE_GET_SEEDING, {seeding_type_id: 44});
              if(data) {
                 this.amountMax = parseInt(data.max_like);
                 this.price = data.fix_coin;
                  this.calculate();

                  if (data.video) {
                      let videoId = this.youtube_parser(data.video);
                      if (videoId) {
                          this.videoId = videoId;
                      }
                  }
              }

              data  =  await this.$store.dispatch(VIP_FACE_GET_SEEDING, {seeding_type_id: 46});
                if(data) {
                    this.priceView = data.fix_coin;
                    this.calculate();
                }
            },


            validateForm() {
              let valid = true;
              // link or ID
              if (this.linkOrId.toString().trim() === '') {
                  return {check: false, message: "Chưa Nhập Link hoặc ID profile cần cài VIP"};
              }
              if (this.amountMin === '') {
                  return {check: false, message: "Chưa Nhập số lượng like nhỏ nhất"};
              }
              if (this.amountMax === '') {
                return {check: false, message: "Chưa Nhập số lượng like lớn nhất"};
              }

              if (parseInt(this.amountMin) > parseInt(this.amountMax)) {
                  return {check: false, message: "Số lượng like nhỏ nhất và lớn nhất không hợp hệ"};
              }

              return {check: valid, message: ""};
            },
            async saveProcess() {
                this.calculate();
                let validateForm = this.validateForm();
                if (validateForm.check) {
                    try {
                        Swal.fire({
                            title: 'Xác nhận',
                            text: "Bạn có chắc chắn muốn tạo tiến trình ",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Đồng ý!',
                            cancelButtonText: 'Không'
                        }).then((result) => {
                            if (result.value) {
                                this.overlay = true;
                                this.saveProcessApi();
                            }
                        })
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    Swal.fire(
                        validateForm.message,
                        '...',
                        'error'
                    )
                }
            },
            getParams() {
                return {
                    post_link: this.linkOrId,
                    min_like: this.amountMin,
                    max_like: this.amountMax,
                    view: this.amountView,
                    days: this.day,
                    max_post_daily: this.maxPost,
                    fix_coin_job: this.price,
                    prices: this.totalCoin,
                    note: this.notes,
                };
            },
            async saveProcessApi() {
                let check = await this.$store.dispatch(TIKTOK_VIP_LIKE_SAVE_ORDER, this.getParams());
                if (check) {
                    this.overlay = false;
                    this.$router.go();
                } else {
                  this.overlay = false;
                }

            },
          async calculate() {
              let param = {
                  seeding_type: 44,
                  max_like: this.amountMax,
                  days: this.day,
                  fix_coin_job: this.price,
                  max_post_daily: this.maxPost
              };
              let price1 = await this.$store.dispatch(VIP_FACE_CALCULATE, param);
              if (price1) {
                  this.totalCoin = price1;
              }
              param = {
                  seeding_type: 46,
                  max_like: this.amountView,
                  days: this.day,
                  fix_coin_job: this.priceView,
                  max_post_daily: this.maxPost
              }
              let price2 = await this.$store.dispatch(VIP_FACE_CALCULATE, param);
              if (price2) {
                  this.totalCoin += price2;
              }

          },

            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .fb-post-create-process {
        background-color: $bgMainColor;
        max-width: 100% !important;

        .v-text-field__details{
            display: none;
        }
        .text-color{
            color: $mainColor;
            font-weight: bold;
        }
        .text-color-vip{
            color: $vip;
            font-weight: bold;
        }
        .div-total {
            width: 100%;
            color: white;
            text-align: center;
        }
        .div-cx {
            height: 60px;
            .cx-img {
                cursor: pointer;
                &hover {
                    opacity: 0.8;
                }
            }
            .cxSelected {
                height: 60px;
                width: 60px;
            }
        }
    }
</style>
